export const csrfToken = (document.querySelector("input[name=csrfmiddlewaretoken]") as HTMLInputElement).value